<div class="provider-login__wrapper">
    <div class="provider-login__img">
        <img src="{{block.data.image_url}}">
    </div>
        
    <div class="provider-login__content">
        <h3 *ngIf="block.data.title">{{block.data.title}}</h3>
        <p *ngIf="block.data.text">{{block.data.text}}</p>
        <a *ngIf="block.data.url" href="{{block.data.url}}" [target]="block.data.target" class="btn btn--small btn-secondary">{{block.data.btnText}}</a>
    </div>
</div>
